import React, { Component } from "react";

import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { sweetAlert } from "../../components/Alert/sweetAlert";

import { renderLegacyTextField } from '../../utils/engageComponents'
import { Tab, Tabs } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

//material ui components
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton';
import { Button, Switch } from "@material-ui/core";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import SwipeableViews from 'react-swipeable-views';
import { ChevronList } from '../../utils/engageComponents';
import { IconsModal } from "../../views/scheduler/IconsModal";

//Icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import {
    AddMessage,
    AddMessageFilter
} from '../../actions/deviceActions';

//3 party Libs
import moment from 'moment';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class LModalMessage extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            activeStep: 0,
            openTranslations: false,
            notificationMessage: true,
            fullscreenMessage: false,
            fixedOptionSelected: undefined,
            messageModalSeconds: 30,
            messageModalHours: 2,
            translationTab: 0,
            fullNotificationIconSelected: undefined,
            fullNotificationIconUrl: undefined,
            openIconsModal: false,
            disabledBackIcon: true,
            disabledFowardIcon: false,
            stepCounter: 0,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }

    handleSelectIcon = (iconObj) => {
        if (iconObj) {
            let iconUrl = iconObj && iconObj.iconUrl ? iconObj.iconUrl : '';
            iconUrl = iconUrl.replace("/Categories", "/Solidblack");

            this.setState({ fullNotificationIconSelected: iconObj, fullNotificationIconUrl: iconUrl, openIconsModal: false })
        }
    }

    async onSubmitHandler(formData) {

        const newMessage = {}
        newMessage.notificationType = this.state.notificationMessage ? "Notification" : "Full"
        newMessage.messageType = this.state.fixedOptionSelected === 1 ? "Normal" : "Reminder"
        newMessage.title = this.state.messageModalTitle;
        newMessage.message = this.state.messageModalMessage;
        newMessage.topics = [];
        newMessage.fullNotificationIconUrl = this.state.fullscreenMessage ? this.state.fullNotificationIconUrl : ""
        newMessage.translations = [];

        const stylesObj = { modalStyles: { backgroundColor: '#ffffff' }, messageClass: 'LAlertMessageStyles' };

        if (this.props.selectAllButton) {
            newMessage.topics.push(``);
        } else {
            this.props.selectedDevices.forEach(selected => {
                newMessage.topics.push(`${selected.residentId}/${selected._id}`);
            });
        }

        const now = moment(new Date()).startOf('minute');
        let messageDate = moment(new Date());
        let messageEnd;

        if (this.state.scheduleDay && this.state.hourSelected && this.state.minuteSelected && this.state.dayTime) {
            messageDate = moment(this.state.scheduleDay.format('MM-DD-YYYY') + ' ' + this.state.hourSelected.number + ':' + this.state.minuteSelected.number + ' ' + this.state.dayTime.text, 'MM-DD-YYYY hh:mm A');
            messageEnd = this.state.notificationMessage ? moment(messageDate).add(this.state.messageModalSeconds, 'm') : moment(messageDate).add(this.state.messageModalHours, 'h')
        }

        if (messageDate < now) {
            let nowHour = now.hour() > 12 ? now.hour() - 12 : now.hour();
            let nowMinute = now.minutes();
            let nowDayTime = now.hour() > 11 ? 'PM' : 'AM';
            let nowDay = now.clone().startOf('day');

            let hourObject = {
                number: undefined,
                text: '',
            }

            let minuteObject = {
                number: undefined,
                text: '',
            }

            const datTimeObject = {
                text: nowDayTime,
            }
            if (nowHour === undefined) {
                hourObject = {
                    number: undefined,
                    text: '',
                }
            } else {

                hourObject = {
                    number: nowHour,
                    text: ('0' + nowHour).slice(-2),
                }
            }

            if (nowMinute === undefined) {
                minuteObject = {
                    number: undefined,
                    text: '',
                }
            } else {

                minuteObject = {
                    number: nowMinute,
                    text: ('0' + nowMinute).slice(-2),
                }
            }
            this.setState({
                hourSelected: hourObject,
                minuteSelected: minuteObject,
                dayTime: datTimeObject,
                scheduleDay: nowDay,
            });

            const message = `Cannot select a time in the past`
            sweetAlert('error', message, 'alert_AddEditActivity_PastTime_Error', stylesObj);

            return;
        }

        if (this.state.messageEs !== '') {
            const spanishObj = {
                languageCode: 'es',
                title: this.state.titleEs,
                message: this.state.messageEs,
            }

            newMessage.translations.push(spanishObj);
        }

        if (this.state.messageFr !== '') {
            const frenchObj = {
                languageCode: 'fr',
                title: this.state.titleFr,
                message: this.state.messageFr,
            }

            newMessage.translations.push(frenchObj);
        }

        newMessage.messageDate = new Date(messageDate);
        newMessage.messageEnd = new Date(messageEnd);

        if (this.props.selectAllButton)
            this.props.AddMessageFilter(localStorage.getItem('communityId'), this.props.filterObj, newMessage, this.props.sortColumn, this.props.sortDesc, stylesObj);
        else
            this.props.AddMessage(newMessage, localStorage.getItem('communityId'), stylesObj);

    }

    //#region  Inner components

    RenderModalContent = () => {

        return (
            <Grid>
                <Paper elevation={3} className="paperLModalMessage" square='false' color='secondary'>
                    <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        <Grid item container>
                            <Grid item justify='center' style={{ width: '100%' }} alignItems='center'>
                                <this.RenderTitleContainer />
                            </Grid>
                            <Grid item justify='center' alignItems='center'>
                                <this.RenderMessageContainer />
                            </Grid>
                            <Grid item container className="ModalButtonsContainer alingCenter" style={{ paddingTop: '60px' }} justify='flex-end'>
                                <this.RenderButtonsContainer />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };


    RenderButtonsContainer = () => {
        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={10}>
                    <Grid item container direction='row-reverse'>
                        <Grid item container className="VoiceSettingModalButtonYes skybluebtn-engage alingCenter">
                            {this.state.activeStep === 2 ?
                                <Grid id='close_repair_close_btn' item container className="alingCenter" onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Register
                                </Grid>
                                :
                                <Grid id='close_repair_close_btn' item container className="alingCenter"
                                    onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }))}
                                >
                                    Continue
                                </Grid>
                            }
                        </Grid>
                        <Grid item container className="VoiceSettingModalButtonCancel alingCenter">
                            {this.state.activeStep > 0 ?
                                <Grid id='close_repair_return_btn' item container className="alingCenter"
                                    onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep - 1 }))}>
                                    Back
                                </Grid>
                                :
                                <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                    Cancel
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    //#region Modal
    Modal = {
        paperModal: {
            backgroundColor: '#1f1f1f',
            padding: '6px',
            width: '35%',
            height: '50%',
            position: 'absolute',
            top: '20%',
            left: '35%'
        },
        stepperModal: {
            height: '10%',
        },
        contentModal: {
            height: '60%',
            padding: '20px'
        },
        buttonsModal: {
            height: '40%',
            justify: 'center',
            marginTop: '20px',
        },
        hiddenButton: {
            display: 'none'
        },
        visibleButton: {
            marginTop: '10px',
            marginLeft: '10px',
            width: '156px'
        },
        visibleDisabledButton: {
            marginTop: '10px',
            marginLeft: '10px',
            backgroundColor: '#ffffff',
            color: '#bdbdbd',
            width: '7rem'
        }
    }

    AddStep = (step) => {

        let newValue = this.state.stepCounter + step;
        this.setState({ stepCounter: newValue });

        if (newValue === 1)
            this.setState({ disabledBackIcon: false, disabledFowardIcon: true });
        else
            this.setState({ disabledBackIcon: true, disabledFowardIcon: false });
    }

    notificationClick = () => {
        const notification = this.state.notificationMessage;

        this.setState({
            notificationMessage: !notification,
            fullscreenMessage: false
        });
    }

    fullClick = () => {
        const full = this.state.fullscreenMessage;

        this.setState({
            notificationMessage: false,
            fullscreenMessage: !full
        });
    }

    onChangeHandler = (e, placeholder) => {

        let timeValue = e.target.value.slice(-2)

        if (placeholder === 'hr') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 12)) {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = 0;

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            } else {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = Number(e.target.value);

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'min') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 59)) {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = 0;

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            } else {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = Number(e.target.value.slice(-2));

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'AM') {
            if (!(e.target.value === 'AM' || e.target.value === 'PM')) {
                this.setState({ dayTime: { text: 'AM' }, fixedOptionSelected: undefined });
            }
        }

    }

    onArrowClick = (order, placeHolder) => {

        if (placeHolder === 'hr') {
            let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
            let hour = hourObject.number ? hourObject.number : 0;

            if (order === 'Up') {

                if ((hour + 1) < 13) {
                    hour = hour + 1;
                }
            }
            else {
                if ((hour - 1) > 0) {
                    hour = hour - 1;
                }
            }

            hourObject.number = hour;
            hourObject.text = ('0' + hour).slice(-2);

            this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
        }

        if (placeHolder === 'min') {
            let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
            let minute = minuteObject.number ? minuteObject.number : 0;
            if (order === 'Up') {

                if ((minute + 1) < 60) {
                    minute = minute + 1;
                }
            }
            else {
                if ((minute - 1) > -1) {
                    minute = minute - 1;
                }
            }

            minuteObject.number = minute;
            minuteObject.text = ('0' + minute).slice(-2)

            this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
        }

        if (placeHolder === 'AM') {
            let dayTime = 'AM';
            if (this.state.dayTime === undefined || this.state.dayTime.text === 'PM') {
                dayTime = 'AM';
            }
            else {
                dayTime = 'PM';
            }

            this.setState({ dayTime: { text: dayTime }, fixedOptionSelected: undefined });
        }
    }

    SelectOptionForMessage = (scheduleDate, option) => {

        let hour = scheduleDate.hour() > 12 ? scheduleDate.hour() - 12 : scheduleDate.hour();
        let minute = scheduleDate.minutes();
        let dayTime = scheduleDate.hour() > 11 ? 'PM' : 'AM';
        let daySelected = scheduleDate.clone().startOf('day');

        if (this.state.fixedOptionSelected && this.state.fixedOptionSelected === option) {
            option = undefined;
            hour = undefined;
            minute = undefined;
            dayTime = undefined;
            daySelected = undefined;
        };

        let hourObject = {
            number: undefined,
            text: '',
        }

        let minuteObject = {
            number: undefined,
            text: '',
        }

        const datTimeObject = {
            text: dayTime,
        }


        if (hour === undefined) {
            hourObject = {
                number: undefined,
                text: '',
            }
        } else {

            hourObject = {
                number: hour,
                text: ('0' + hour).slice(-2),
            }
        }

        if (minute === undefined) {
            minuteObject = {
                number: undefined,
                text: '',
            }
        } else {

            minuteObject = {
                number: minute,
                text: ('0' + minute).slice(-2),
            }
        }


        this.setState({
            fixedOptionSelected: option,
            hourSelected: hourObject,
            minuteSelected: minuteObject,
            dayTime: datTimeObject,
            scheduleDay: daySelected,
        });

    }

    handleDayClick = (day, today) => {

        if (day >= today) { this.setState({ scheduleDay: day }) }

        if (this.state.fixedOptionSelected !== undefined) {

            setTimeout(() => {

                const daySelected = moment(this.state.scheduleDay).format('DDDD');
                const todayD = moment(today).format('DDDD');
                const Tomorrow = moment(today).add(1, 'day').format('DDDD');

                if ((this.state.fixedOptionSelected === 1 || this.state.fixedOptionSelected === 2) && daySelected !== todayD) {

                    this.setState({ fixedOptionSelected: undefined });

                }
                else if (this.state.fixedOptionSelected === 3 && daySelected !== Tomorrow) {

                    this.setState({ fixedOptionSelected: undefined });

                }
            }, 300);
        }
    }

    isOnError = (field) => {

        switch (field.toLocaleLowerCase()) {
            case 'registrationcode':
                this.setState({ onErrorModalRegistrationCode: (this.state.registrationCode === '' || this.state.registrationCode === undefined) });
                break;
            default: break;

        }
    };

    handleOnchangeTitleField = (value) => {

        let validValue = value;

        if (value.length > 25) {
            validValue = value.substring(0, value.length - (value.length - 25));
            this.setState(
                {
                    onErrorModalTitle: true,
                    messageModalTitle: validValue,
                    errorMaxCharactersTitle: 'The title can only contain up to 25 characters'
                }
            );

        } else {
            this.setState(
                {
                    onErrorModalTitle: value.length > 0 ? false : true,
                    messageModalTitle: validValue,
                    errorMaxCharactersTitle: undefined
                }
            );
        }
    }

    handleOnchangeMessageField = (value) => {
        let validValue = value;

        if (this.state.fullscreenMessage && value.length > 220) {

            validValue = value.substring(0, value.length - (value.length - 220));

            this.setState(
                {
                    onErrorModalMessage: true,
                    messageModalMessage: validValue,
                    errorMaxCharactersBody: 'The body of the message can only contain up to 220 characters'

                }
            );
        } else if (!this.state.fullscreenMessage && value.length > 40) {
            validValue = value.substring(0, value.length - (value.length - 40));

            this.setState(
                {
                    onErrorModalMessage: true,
                    messageModalMessage: validValue,
                    errorMaxCharactersBody: 'The message can only contain up to 40 characters'

                }
            );
        }
        else {
            this.setState(
                {
                    onErrorModalMessage: value.length > 0 ? false : true,
                    messageModalMessage: validValue,
                    errorMaxCharactersBody: undefined
                }
            );
        }

    }

    handleOnchangeMessageTime = (value) => {
        if (this.state.fullscreenMessage)
            this.setState(
                {
                    messageModalHours: value
                }
            );
        else
            this.setState(
                {
                    messageModalSeconds: value
                }
            );
    }


    handleChangeTab = (event, newValue) => {
        this.setState({ translationTab: newValue });
    };

    a11yProps(lng) {
        return {
            id: `vertical-translation-tab-${lng}`,
            'aria-controls': `vertical-tabpanel-${lng}`,
        };
    }

    handleChangeTranslationIndex = (index) => {
        this.setState({ translationTab: index })
    }

    //#endregion Modal

    RenderMessageContainer = () => {

        const week = [0, 1, 2, 3, 4, 5, 6];
        const thumbClass = this.state.openTranslations ? 'switchThumbChecked' : 'switchThumb'
        const trackClass = this.state.openTranslations ? 'switchTrackChecked' : 'switchTrack'

        const RenderModalDayComponent = ({ daysToAdd }) => {

            let day = "";
            if (this.state.stepCounter === 0)
                day = moment(new Date()).add(daysToAdd, 'days');
            else
                day = moment(new Date()).add(daysToAdd + 7, 'days');

            const today = moment(new Date());
            const scheduleDay = this.state.scheduleDay ? this.state.scheduleDay : undefined;
            const sameDay = day.format('yyyy/MM/DD') === today.format('yyyy/MM/DD') ? true : false;
            const isScheduleDay = scheduleDay ? scheduleDay.format('yyyy/MM/DD') === day.format('yyyy/MM/DD') : false;

            return (
                <Grid item className={day < today ? "LscheduleModalDisabledCell" : "LscheduleModalCell"} onClick={() => this.handleDayClick(day, today)}>
                    <Grid item className="LdayTitle">{day.format('ddd').toUpperCase()}</Grid>
                    <Grid item className={isScheduleDay ? "LscheduleModalDate LscheduleModalScheduleDay" : sameDay ? "LscheduleModalDate LscheduleModalToday" : "LscheduleModalDate"}>{day.format('D')}</Grid>
                </Grid>
            );
        };

        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={10} className="VoiceSubTitleModal">
                    {
                        <Grid item container xs={12} justify='center' alignItems='center' >
                            <Stepper nonLinear activeStep={this.state.activeStep} className="stepperModal">
                                <Step key={0} className={this.state.activeStep > 0 ? "StepStyles" : ""}><StepLabel onClick={() => { this.setState({ activeStep: 0 }) }} className={this.state.activeStep > 0 ? "StepLabelStyles" : ""}></StepLabel></Step>
                                <Step key={1} className={this.state.activeStep > 1 ? "StepStyles" : ""}><StepLabel onClick={() => { this.setState({ activeStep: 1 }) }} className={this.state.activeStep > 1 ? "StepLabelStyles" : ""}></StepLabel></Step>
                                <Step key={2}><StepLabel></StepLabel></Step>
                            </Stepper>
                        </Grid>
                    }
                    <Grid container xs={12} justify='center' alignItems='center'>
                        <SwipeableViews
                            axis={'x'}
                            index={this.state.activeStep}
                            onChangeIndex={this.handleChangeIndex}
                            style={{ width: '95%', height: '100%', padding: '0', }}
                        >
                            {/* TabPanel Names */}
                            <TabPanel value={this.state.activeStep} index={0} dir={'x'} style={{ padding: '0', }} >
                                <Grid container xs={12} justify='center' alignItems='space-between'>
                                    <Grid item container xs={12} justify='center' alignItems='center' className="LsubtitleResidentModal">
                                        <Grid item >
                                            Select Type
                                        </Grid>
                                    </Grid>
                                    <Grid item container xs={12} justify='center' alignItems='center'>
                                        <Grid id='device_messageModal_notificationtype' item container xs={5} justify='center' alignItems='center' onClick={() => this.notificationClick()} className={this.state.notificationMessage ? 'deviceModalTypeSection deviceModalTypeSelected' : 'deviceModalTypeSection'}>
                                            <Grid container xs={10} direction='colum' className='deviceGridColum'>
                                                <Grid container xs={4} direction='colum' className='deviceModalNotification'>
                                                </Grid>
                                            </Grid>
                                            <Grid item container justify='center'>
                                                <Grid item xs={12} className='LdeviceModalTitle'>
                                                    <span>Notification</span>
                                                </Grid>
                                                <Grid item xs={12} className='LdeviceModalDescription'>
                                                    <span>Non-intrusive. Auto-hides after 30 seconds of inaction.</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid id='device_messageModal_fullscreentype' item container xs={5} justify='center' alignItems='center' onClick={() => this.fullClick()} className={this.state.fullscreenMessage ? 'deviceModalTypeSection deviceModalTypeSelected' : 'deviceModalTypeSection'}>
                                            <Grid container xs={10} direction='colum' className='deviceGridColumFull'>
                                                <Grid container xs={12} direction='colum' className='deviceModalFullscreen-Line'>
                                                </Grid>
                                                <Grid container xs={7} direction='colum' className='deviceModalFullscreen-Line'>
                                                </Grid>
                                                <Grid container xs={9} direction='colum' className='deviceModalFullscreen-Line'>
                                                </Grid>
                                                <Grid container xs={6} direction='colum' alignItems='center' className='deviceModalFullscreen'>
                                                </Grid>
                                            </Grid>
                                            <Grid item container justify='center'>
                                                <Grid item xs={12} className='LdeviceModalTitle'>
                                                    <span>Fullscreen</span>
                                                </Grid>
                                                <Grid item xs={12} className='LdeviceModalDescription'>
                                                    <span>Disruptive. Requires user action for dismissal.</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </TabPanel>

                            {/* TabPanel Profile Picture */}
                            <TabPanel value={this.state.activeStep} index={1} dir={'x'} style={{ padding: '0', }}>
                                <Grid container justify='center' alignItems='space-between'>
                                    <Grid item container xs={12} justify='center' alignItems='center' className="LsubtitleResidentModal">
                                        <Grid item>
                                            Enter Message Details
                                        </Grid>
                                    </Grid>
                                    <Grid item container xs={7} justify='center' alignItems='center'>
                                        {
                                            this.state.fullscreenMessage ?
                                                <Grid item container xs={12} md={12} lg={6} justify='flex-start' direction='column' style={{ paddingBottom: '25px', }}>
                                                    <img
                                                        src={this.state.fullNotificationIconUrl}
                                                        alt='No icon selected'
                                                        className="iconStyleDevice"
                                                    />
                                                    <Button id='select_icon_btn' variant='filled' className={this.state.fullNotificationIconSelected ? "SelectIconBtn SelectIconBtnIconSelected" : "SelectIconBtn"} onClick={() => { this.setState((prevState) => ({ openIconsModal: !prevState.openIconsModal })); }}>
                                                        Select Icon
                                                    </Button>
                                                </Grid> : ""
                                        }
                                        <Grid item xs={12} className="LcontentModal">
                                            {
                                                this.state.fullscreenMessage ?
                                                    <Grid xs={12}>
                                                        <TextField
                                                            id='device_messageModal_messagedetails_title'
                                                            error={this.state.onErrorModalTitle}
                                                            onBlur={() => {
                                                                this.isOnError('title')
                                                                this.setState({ isFocusTitle: false })
                                                            }}
                                                            helperText={(!this.state.messageModalTitle || (this.state.messageModalTitle && this.state.messageModalTitle.length <= 0)) ? this.state.errorGenericText : this.state.errorMaxCharactersTitle ? this.state.errorMaxCharactersTitle : undefined}
                                                            className='LTextField'
                                                            style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                            label={'Title'}
                                                            placeholder={'Title'}
                                                            value={this.state.messageModalTitle}
                                                            onChange={(e) => { this.handleOnchangeTitleField(e.target.value) }}
                                                            onFocus={() => { this.setState({ isFocusTitle: true }) }}
                                                        />
                                                        {
                                                            this.state.isFocusTitle ?
                                                                <Grid item xs={12} style={{ textAlign: 'right', opacity: '.56', fontFamily: 'Gotham-Book', paddingRight: '10px' }}>
                                                                    {this.state.messageModalTitle ? this.state.messageModalTitle.length : 0}/25
                                                                </Grid>
                                                                :
                                                                undefined
                                                        }
                                                    </Grid>

                                                    : ""
                                            }
                                        </Grid>
                                        <Grid item xs={12} className="LcontentModal">
                                            <TextField
                                                id='device_messageModal_messagedetails_message'
                                                autoFocus={this.setState.notificationMessage}
                                                error={this.state.onErrorModalMessage}
                                                onBlur={() => {
                                                    this.isOnError('message')
                                                    this.setState({ isFocusMessage: false })
                                                }}
                                                helperText={(!this.state.messageModalMessage || (this.state.messageModalMessage && this.state.messageModalMessage.length <= 0)) ? this.state.errorGenericText : this.state.errorMaxCharactersBody ? this.state.errorMaxCharactersBody : undefined}
                                                className='LTextField'
                                                style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                label={'Message'}
                                                placeholder={'Message'}
                                                value={this.state.messageModalMessage}
                                                onChange={(e) => { this.handleOnchangeMessageField(e.target.value) }}
                                                onFocus={() => { this.setState({ isFocusMessage: true }) }}
                                            />

                                            {this.state.isFocusMessage ?
                                                <Grid item xs={12} style={{ textAlign: 'right', opacity: '.56', fontFamily: 'Gotham-Book', paddingRight: '10px' }}>
                                                    {
                                                        (this.state.fullscreenMessage) ?
                                                            this.state.messageModalMessage ? this.state.messageModalMessage.length + '/220' : 0 + '/220'
                                                            :
                                                            this.state.messageModalMessage ? this.state.messageModalMessage.length + '/40' : 0 + '/40'
                                                    }
                                                </Grid>
                                                :
                                                undefined
                                            }
                                        </Grid>
                                        <Grid item xs={12} className="LcontentModal">
                                            {
                                                this.state.fullscreenMessage ?
                                                    <TextField
                                                        id='device_messageModal_messagedetails_durationmin'
                                                        style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                        label={'Duration (Hours)'}
                                                        className='LTextField'
                                                        placeholder={'Hours'}
                                                        inputProps={{
                                                            step: 1,
                                                            min: 0,
                                                            max: 12,
                                                            type: 'number'
                                                        }}
                                                        value={this.state.messageModalHours}
                                                        onChange={(e) => { this.handleOnchangeMessageTime(e.target.value) }}
                                                    /> :
                                                    <TextField
                                                        id='device_messageModal_messagedetails_durationhr'
                                                        style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                        label={'Duration (Seconds)'}
                                                        className='LTextField'
                                                        placeholder={'Seconds'}
                                                        disabled
                                                        value={this.state.messageModalSeconds}
                                                        onChange={(e) => { this.handleOnchangeMessageTime(e.target.value) }}
                                                    />
                                            }
                                        </Grid>
                                        <Grid item container xs={12} alignItems='center' justify='flex-end' style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                                            <span style={{ fontWeight: 'bold', textAlign: 'left', fontSize: '20px', opacity: '.56', color: 'white', marginRight: '1rem' }}>Add other translations</span>
                                            <Switch
                                                classes={{
                                                    root: 'switchRoot',
                                                    thumb: thumbClass,
                                                    track: trackClass,
                                                }}
                                                checked={this.state.openTranslations}
                                                onClick={() => this.setState((prevState) => ({ openTranslations: !prevState.openTranslations }))}>
                                            </Switch>

                                        </Grid>
                                        {
                                            this.state.openTranslations &&
                                            <Grid item container xs={12} className='LcontentModal'>
                                                <Tabs
                                                    value={this.state.translationTab}
                                                    onChange={this.handleChangeTab}
                                                    aria-label="Translations tab"
                                                    className='translationTabs'
                                                    variant='scrollable'
                                                    TabIndicatorProps={{ style: { backgroundColor: '#009edd' } }}

                                                >
                                                    <Tab label="ES" className={(this.state.translationTab === 0) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(0)} />
                                                    <Tab label="FR" className={(this.state.translationTab === 1) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(1)} />
                                                </Tabs>

                                                <SwipeableViews
                                                    axis='x'
                                                    index={this.state.translationTab}
                                                    onChangeIndex={this.handleChangeTranslationIndex}
                                                >

                                                    <TabPanel value={0} index={0}>

                                                        {
                                                            this.state.fullscreenMessage &&
                                                            <Grid item container xs={12} style={{ marginBottom: '1rem' }}>
                                                                <Field
                                                                    name="titleEs"
                                                                    label="Titulo"
                                                                    maxLength={20}
                                                                    onChange={(e, newItem) => this.setState({ titleEs: newItem })}
                                                                    component={renderLegacyTextField}
                                                                    id='title_es'
                                                                />

                                                            </Grid>

                                                        }

                                                        <Grid item container xs={12}>
                                                            <Field
                                                                name="messageEs"
                                                                label="Mensaje"
                                                                maxLength={20}
                                                                onChange={(e, newItem) => this.setState({ messageEs: newItem })}
                                                                component={renderLegacyTextField}
                                                                id='message_es'
                                                            />
                                                        </Grid>
                                                    </TabPanel>

                                                    <TabPanel value={1} index={1}>

                                                        {
                                                            this.state.fullscreenMessage &&
                                                            <Grid item container xs={12} style={{ marginBottom: '1rem' }}>
                                                                <Field
                                                                    name="titleFr"
                                                                    label="Titre"
                                                                    maxLength={20}
                                                                    onChange={(e, newItem) => this.setState({ titleFr: newItem })}
                                                                    component={renderLegacyTextField}
                                                                    id='title_fr'
                                                                />
                                                            </Grid>
                                                        }


                                                        <Grid item container xs={12}>
                                                            <Field
                                                                name="messageFr"
                                                                label="message"
                                                                maxLength={20}
                                                                onChange={(e, newItem) => this.setState({ messageFr: newItem })}
                                                                component={renderLegacyTextField}
                                                                id='message_fr'
                                                            />

                                                        </Grid>
                                                    </TabPanel>

                                                </SwipeableViews>


                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </TabPanel>

                            {/* TabPanel Tags */}
                            <TabPanel value={this.state.activeStep} index={2} dir={'x'} style={{}}>
                                <Grid container justify='center' alignItems='space-between'>
                                    <Grid item container xs={12} justify='center' alignItems='center' className="LsubtitleResidentModal">
                                        <Grid item >
                                            Schedule Message
                                        </Grid>
                                    </Grid>
                                    <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity LcontentModalPadding">
                                        {/* fixed options */}
                                        <Grid item container xs={12} justify='center' alignItems='center'>
                                            <Grid id='device_messageModal_schedulemessage_nowscheduleoption' item className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 1) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()), 1)}>Now</Grid>
                                            {
                                                moment(new Date()).hour() < 12 ?
                                                    <Grid id='device_messageModal_schedulemessage_noontodayscheduleoption' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 2) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()).startOf('day').add(12, 'hours'), 2)}>Noon Today</Grid>
                                                    :
                                                    undefined
                                            }
                                            {
                                                moment(new Date()).day() !== 6 ?
                                                    <Grid id='device_messageModal_schedulemessage_noontomorrowscheduleoption' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 3) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()).add(1, 'days').startOf('day').add(12, 'hours'), 3)}>Noon Tomorrow</Grid>
                                                    :
                                                    undefined
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item container xs={12} alignItems='center' justify='center' className="LcontentModal LcontentModalPadding">
                                        <Grid item container xs={1} justify='center' alignItems='center'>
                                            <IconButton id='device_messageModal_schedulemessage_backwardarrow' aria-label="leftArrow" onClick={() => this.AddStep(-1)} disabled={this.state.disabledBackIcon}>
                                                <ArrowBackIosIcon style={{ fontSize: 40, color: (this.state.disabledBackIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                            </IconButton>
                                        </Grid>
                                        <Grid item container xs={10} justify='center' alignItems='center'>
                                            {
                                                week ? week.map(
                                                    day => {
                                                        return (
                                                            <RenderModalDayComponent key={'DayComponent' + day} daysToAdd={day} />
                                                        );
                                                    }
                                                ) :
                                                    undefined
                                            }
                                        </Grid>
                                        <Grid item container xs={1} justify='center' alignItems='center'>
                                            <IconButton id='device_messageModal_schedulemessage_forwardarrow' aria-label="RightArrow" onClick={() => this.AddStep(1)} disabled={this.state.disabledFowardIcon}>
                                                <ArrowForwardIosIcon style={{ fontSize: 40, color: (this.state.disabledFowardIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                    <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity LcontentModalPadding">
                                        {/* Time Selection */}
                                        <Grid item container xs={9} justify='space-between' className="scheduleModalTimeListDevices">
                                            <Grid item container xs={4}>
                                                <ChevronList
                                                    idToSet='device_messageModal_schedulemessage_hr'
                                                    onArrowClick={this.onArrowClick}
                                                    onChangeHandler={this.onChangeHandler}
                                                    textClass='LChevronListText'
                                                    optionSelected={this.state.hourSelected}
                                                    placeHolder='hr'
                                                />
                                            </Grid>
                                            <Grid item xs={1} className="LmodalColon">:</Grid>
                                            <Grid item xs={4}>
                                                <ChevronList
                                                    idToSet='device_messageModal_schedulemessage_min'
                                                    onArrowClick={this.onArrowClick}
                                                    onChangeHandler={this.onChangeHandler}
                                                    textClass='LChevronListText'
                                                    optionSelected={this.state.minuteSelected}
                                                    placeHolder='min'
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <ChevronList
                                                    idToSet='device_messageModal_schedulemessage_daytime'
                                                    onArrowClick={this.onArrowClick}
                                                    onChangeHandler={this.onChangeHandler}
                                                    textClass='LChevronListText'
                                                    optionSelected={this.state.dayTime}
                                                    placeHolder='AM'
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </TabPanel>

                        </SwipeableViews>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderTitleContainer = () => {
        return (
            <>
                <Grid item container xs={12} direction='row-reverse'>
                    <div className="engage-nav VoiceTitleModal" onClick={() => this.props.OnCancelHandler()}>
                        <img
                            src='https://engage360.s3.amazonaws.com/Icons/Solidblack/circle-xmark.svg'
                            alt='close'
                            className="closeIcon"
                            height="35px"
                        />
                    </div>
                </Grid>
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10} className="LMultipleDeleteModalTitle">
                        <Grid>Message</Grid>
                    </Grid>
                </Grid>
            </>
        );
    }
    //#endregion

    render() {
        return (
            <>
                <main style={{}}>
                    <div>
                        <this.RenderModalContent />
                    </div>
                </main>

                {
                    this.state.openIconsModal === true ?

                        <IconsModal
                            icons={this.props.IconsData}
                            onSelectIcon={this.handleSelectIcon}
                            iconSelected={this.state.fullNotificationIconSelected}
                            onClose={() => { this.setState({ openIconsModal: false }) }}
                        />
                        :
                        undefined
                }
            </>

        )
    }
}

function mapStateToProps(state, dispatch) {

    const IconsData = (state.categoryReducer && state.categoryReducer.IconsData) ? state.categoryReducer.IconsData : [];

    return {
        IconsData: IconsData
    }
}


LModalMessage = reduxForm({
    form: 'LModalMessageForm',
    enableReinitialize: true,
})(LModalMessage);

export default connect(mapStateToProps, { AddMessage, AddMessageFilter })(LModalMessage);

